export default (type, action) => `@@${type}/${action}`;
